import { Link, createFileRoute } from '@tanstack/react-router'
import { Video } from 'lucide-react'

import { PageBackButton } from '@/components/common/PageBackButton'
import { Button } from '@/components/ui/button'
import { SharedAreaMap } from '@/components/growers/area-map/shared-area-map'
import { useAuth } from '@/hooks/use-auth'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/agriculture/area-map',
)({
    component: AreaMapPage,
})

/**
 * Bản đồ vùng trồng chung: bản đồ chiếm trọn vùng nội dung. Desktop <main> có
 * chiều cao cố định (lg:h-screen) nên h-full là đủ; mobile shell cuộn body nên
 * đặt chiều cao theo viewport để bản đồ không co về 0.
 */
export function AreaMapPage() {
    const { hasPermission } = useAuth()
    if (!hasPermission('growers.read')) {
        return (
            <div className="p-8 text-center text-destructive">
                {m.common_permission_denied()}
            </div>
        )
    }
    return (
        <div className="flex h-[calc(100svh-4rem)] flex-col lg:h-full">
            <div className="flex items-center justify-between border-b px-4 py-2">
                <div className="flex min-w-0 items-center gap-2">
                    <PageBackButton className="-my-2 md:-my-1" />
                    <h1 className="text-base font-semibold">
                        {m.area_map_title()}
                    </h1>
                </div>
                {hasPermission('cameras.read') && (
                    <Button asChild variant="outline" size="sm">
                        <Link to="/agriculture/cameras">
                            <Video className="size-4" />
                            {m.camera_overview_open()}
                        </Link>
                    </Button>
                )}
            </div>
            <div className="relative min-h-0 flex-1">
                <SharedAreaMap />
            </div>
        </div>
    )
}
